import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";

export default function useGolfWeatherIntegration() {
  const store = useStore();

  const targetCourse = ref(null);
  const targetGolfWeatherId = ref("");
  const golfWeatherIdLastUpdated = ref("");

  const loadingSetup = ref(false);
  const courses = computed(() => store.getters["courses/getCourseNames"]);

  watch(targetCourse, async (newVal) => {
    if (newVal) {
      const response = await store.dispatch(
        "golfWeather/fetchGolfWeatherId",
        newVal.id
      );

      if (!response || response.status === 400) {
        targetGolfWeatherId.value = "";
        golfWeatherIdLastUpdated.value = "";
      } else {
        targetGolfWeatherId.value = response.golfweatherId || "";
        golfWeatherIdLastUpdated.value = response.lastUpdatedAt || "";
      }
    } else {
      targetGolfWeatherId.value = "";
      golfWeatherIdLastUpdated.value = "";
    }
  });

  const setupIntegration = async () => {
    loadingSetup.value = true;

    try {
      const payload = {
        id: targetCourse.value.id,
        golfWeatherId: targetGolfWeatherId.value,
      };
      const response = await store.dispatch(
        "golfWeather/updateCourseIntegration",
        payload
      );

      store.dispatch("toastNotification/displayToast", {
        message: response.data?.message + ` Course updated successfully`,
        type: "success",
        duration: 3000,
      });
      loadingSetup.value = false;
    } catch (error) {
      store.dispatch("toastNotification/displayToast", {
        message:
          error.status === 422
            ? `Invalid Golf Weather ID. Please check the ID and try again.`
            : `Failed to setup integration for ${targetCourse.value.name}`,
        type: "error",
        duration: 6000,
      });
      console.error("Error updating course integration:", error);
      loadingSetup.value = false;
    }
    console.log("Setting up integration for course:", targetCourse.value);
  };

  onMounted(() => {
    store.dispatch("courses/fetchCourseNames");
  });

  return {
    targetCourse,
    targetGolfWeatherId,
    courses,
    loadingSetup,
    setupIntegration,
    golfWeatherIdLastUpdated,
  };
}
